const Copy = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5023 19.5047H6.49672C5.94409 19.5047 5.49609 19.0567 5.49609 18.5041V7.49719"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="7.49805"
      y="4.49532"
      width="11.0069"
      height="13.0081"
      rx="1"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
)

export default Copy
